// extracted by mini-css-extract-plugin
export default {"Button":"ButtonPrimary_Button__eSTCO","Disabled":"ButtonPrimary_Disabled__Lt-6Y"};